function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTravel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 1.711,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.58,14.713L14.617,10.601C13.678,10.252 12.637,10.303 11.743,10.753L9.161,12.041C8.536,12.356 8.491,13.228 9.076,13.605L17.339,18.92L11.799,21.75L8.525,20.293C8.036,20.074 7.468,20.085 6.989,20.327L5.178,21.232C4.655,21.497 4.514,22.177 4.897,22.622L9.009,27.42C9.352,27.819 9.853,28.05 10.376,28.05L18.121,28.05C18.403,28.05 18.678,27.982 18.926,27.859L34.276,20.186C36.892,18.875 38.917,16.625 39.946,13.886C40.481,12.469 39.429,10.95 37.91,10.95L34.681,10.95C33.545,10.95 32.42,11.22 31.408,11.737L25.58,14.713ZM4.149,35.25C4.149,36.245 4.953,37.05 5.949,37.05L38.349,37.05C39.344,37.05 40.149,36.245 40.149,35.25C40.149,34.254 39.344,33.45 38.349,33.45L5.949,33.45C4.953,33.45 4.149,34.254 4.149,35.25Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTravel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/travel.a30ed177eda2c497b00fd12cd43764ac.svg";